query getMarketSpark($ids: [String]) {
    getMarketSpark(ids: $ids)
}

